import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

/**
 * AddSpeciesDialog - Dialog for adding a new species to a group
 * 
 * @param {boolean} isOpen - Controls dialog visibility
 * @param {function} onClose - Callback when dialog is closed
 * @param {string} selectedGroup - Currently selected group (read-only)
 * @param {string} speciesName - New species name value
 * @param {function} onSpeciesNameChange - Callback when species name changes
 * @param {function} onAddClick - Callback when "Legg til art" is clicked
 */
export default function AddSpeciesDialog({
  isOpen,
  onClose,
  selectedGroup,
  speciesName,
  onSpeciesNameChange,
  onAddClick
}) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onAddClick();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md z-[300]">
        <DialogHeader>
          <DialogTitle>Legg til ny art</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Gruppe</Label>
            <Input
              value={selectedGroup}
              disabled
              className="mt-2 bg-slate-100"
            />
          </div>
          <div>
            <Label>Artnavn *</Label>
            <Input
              value={speciesName}
              onChange={(e) => onSpeciesNameChange(e.target.value)}
              placeholder="f.eks. Thalassiosira"
              className="mt-2"
              onKeyDown={handleKeyDown}
            />
          </div>
          <div className="flex space-x-2">
            <Button 
              onClick={onAddClick} 
              className="flex-1 bg-teal-600 hover:bg-teal-700"
            >
              Legg til art
            </Button>
            <Button 
              variant="outline" 
              onClick={() => {
                onClose(false);
                onSpeciesNameChange('');
              }} 
              className="flex-1"
            >
              Avbryt
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
